import { render, staticRenderFns } from "./journalWin.vue?vue&type=template&id=bb8fb0c0&scoped=true&"
import script from "./journalWin.vue?vue&type=script&lang=js&"
export * from "./journalWin.vue?vue&type=script&lang=js&"
import style0 from "./journalWin.vue?vue&type=style&index=0&id=bb8fb0c0&prod&lang=css&"
import style1 from "./journalWin.vue?vue&type=style&index=1&id=bb8fb0c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8fb0c0",
  null
  
)

export default component.exports